jQuery(document).ready(function ($) {
  "use strict";

  /* ----------------------------------------
     Ensure overlay & mobile menu shells exist
  ----------------------------------------- */
  if (!$(".mobile-menu-overlay").length) {
    $("body").append('<div class="mobile-menu-overlay" aria-hidden="true"></div>');
  }

  $("nav.dt-sc-flex-space-between").each(function () {
    var d = $(this).data("menu");
    if (!$('.mobile-menu[data-menu="' + d + '"]').length) {
      $("body").append('<div class="mobile-menu" data-menu="' + d + '"></div>');
    }
  });

  function buildMobileNav() {
    if ($(window).width() < 1281) {
      $("ul.secondary__nav").each(function () {
        var html = $(this).html();
        if (html && $("ul.dt-desktop-menu > li.injected-secondary").length === 0) {
          $('<li class="injected-secondary"></li>')
            .insertAfter("ul.dt-desktop-menu > li:last-child")
            .html(html);
        }
      });

      $("nav.dt-sc-flex-space-between").each(function () {
        var d = $(this).data("menu"),
          $src = $(this).find('ul[data-menu="' + d + '"]'),
          $clone = $src.clone().removeClass("dt-nav"),
          $target = $('.mobile-menu[data-menu="' + d + '"]');

        $("[data-animation]", $clone).removeClass(function () {
          return $(this).attr("data-animation");
        });

        if (!$target.children().length) {
          $clone.prependTo($target);
        }
      });
    } else {
      $(".mobile-menu").empty();
      $("ul.dt-desktop-menu > li.injected-secondary").remove();
    }
  }

  function openMobNav() {
    $("body, .mobile-menu").addClass("nav-is-visible");
    $(".mobile-menu-overlay").addClass("is-visible");
    $(".menu-trigger").attr("aria-expanded", "true");
  }

  function closeMobNav() {
    $("body, .mobile-menu").removeClass("nav-is-visible");
    $(".mobile-menu-overlay").removeClass("is-visible");
    $(".menu-item-has-children a").removeClass("selected");
    $(".menu-item-has-children .sub-menu-block").addClass("is-hidden");
    $(".menu-trigger").attr("aria-expanded", "false");
  }

  function toggleMobNav() {
    $("body").hasClass("nav-is-visible") ? closeMobNav() : openMobNav();
  }

  $(document)
    .on("click.mobile", ".menu-trigger", function (e) {
      e.preventDefault();
      toggleMobNav();
    })
    .on("click.mobile", ".mobile-menu-overlay, li.close-nav", closeMobNav)
    .on("keydown.mobile", function (e) {
      if (e.key === "Escape") closeMobNav();
    })
    .on("click.mobile", ".menu-item-has-children > a", function (e) {
      if ($("body").hasClass("nav-is-visible")) {
        e.preventDefault();
        var $a = $(this),
          $panel = $a.next(".sub-menu-block");
        $a.toggleClass("selected");
        $panel.toggleClass("is-hidden");
      }
    })
    .on("click.mobile", ".go-back", function () {
      $(this).closest(".sub-menu-block").addClass("is-hidden");
    });

  function bindDesktopMenu() {
    if ($(window).width() > 1280) {
      $(".menu-item-has-children > a").on("mouseenter mouseleave", function () {
        $(this).toggleClass("selected")
          .next(".sub-menu-block")
          .toggleClass("is-hidden");
      });
    }
  }

  buildMobileNav();
  bindDesktopMenu();

  $(window).on("resize", function () {
    buildMobileNav();
    bindDesktopMenu();
    closeMobNav();
  });
});
